import { render, staticRenderFns } from "./SimpleBarChart.vue?vue&type=template&id=5b43082d&scoped=true&"
import script from "./SimpleBarChart.vue?vue&type=script&lang=js&"
export * from "./SimpleBarChart.vue?vue&type=script&lang=js&"
import style0 from "./SimpleBarChart.vue?vue&type=style&index=0&id=5b43082d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b43082d",
  null
  
)

export default component.exports